import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=6c34aef8&scoped=true"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"
import style0 from "./SocialIcon.vue?vue&type=style&index=0&id=6c34aef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34aef8",
  null
  
)

export default component.exports